module["exports"] = [
  "Sr.",
  "Sra.",
  "Srta.",
  "Dr."
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/pt_BR/name/prefix.js
 ** module id = 966
 ** module chunks = 0
 **/